/**
 * Was das Anlegen auslöst, so wie der Server es tut (ManualBookingService): Sperre auf allen
 * Kanälen, Zahlungsaufforderung per Stripe, Gastzugang nach der Zahlung.
 */
import { useTranslation } from 'react-i18next';

export function ManualBookingAfter({ hasEmail, total }: { hasEmail: boolean; total?: number }) {
  const { t } = useTranslation('manualBooking');
  const steps = [
    t('afterAvailability'),
    total === 0 ? t('afterZero') : hasEmail ? t('afterPaymentEmail') : t('afterPaymentWaiting'),
    total === 0 ? t('afterAccessZero') : t('afterAccessPaid'),
    t('afterList'),
  ];
  return (
    <section
      aria-labelledby="manual-after"
      className="bg-paper rounded-tile flex flex-col gap-1.5 px-4 py-3.5"
    >
      <h3 id="manual-after" className="font-serif text-base font-bold">
        {t('afterTitle')}
      </h3>
      <ul className="text-ink-soft flex flex-col gap-1 text-[13px]">
        {steps.map((step) => (
          <li key={step}>· {step}</li>
        ))}
      </ul>
    </section>
  );
}
